import React, {createRef, useContext} from "react";
import {Fade, Slide, Flip} from "react-reveal";
import "./EducationCard.scss";
import StyleContext from "../../contexts/StyleContext";

export default function EducationCard({school}) {
  const imgRef = createRef();
  const {isDark} = useContext(StyleContext);

  if (!school.logo)
    console.error(`Image of ${school.name} is missing in education section`);
  
  return (
    <div>
      <Fade left duration={1000}>
        <div className="education-card">
        <Flip left duration={3000}>
          {school.logo && (
              <a href={school.url} target={"_blank"} rel="noreferrer">
              <img
                crossOrigin={"anonymous"}
                ref={imgRef}
                className="education-roundedimg"
                src={school.logo}
                alt={school.schoolName}
              />
              </a>
          )}
        </Flip>
          <div className="education-card-right">
            <h5 className="education-text-school">{school.schoolName}</h5>
            <h5
                className={
                  isDark
                    ? "dark-mode education-text-subHeader"
                    : "education-text-subHeader"
                }
              >
                {school.subHeader}
            </h5>
            <p
                className={`${
                  isDark ? "dark-mode" : ""
                } education-text-duration`}
              >
                {school.duration}
            </p>
          </div>
        </div>
      </Fade>
      <Slide left duration={2000}>
        <div className="education-card-border"></div>
      </Slide>
    </div>
  );
}
